import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { customColorSets } from '../../../utils/custom-color-sets';
import { BarGroupedOptions } from '../../../utils/models/bar-grouped-options';

/**
 * Bar vertical grouped chart
 * @author Prasanth Venkatesan
 */
@Component({
  selector: 'neu-charts-bar-vertical-grouped',
  template: `<div class="chart-container" *ngIf="data && (data.length > 0)">
    <ngx-charts-bar-vertical-2d
      [scheme]="colorScheme"
      [results]="data"
      [gradient]="gradient"
      [xAxis]="options.showXAxis"
      [yAxis]="options.showYAxis"
      [legend]="options.showLegend"
      [showXAxisLabel]="options.showXAxisLabel"
      [showYAxisLabel]="options.showYAxisLabel"
      [xAxisLabel]="options.xAxisLabel"
      [yAxisLabel]="options.yAxisLabel"
      [barPadding]="options.barPadding"
      [groupPadding]="options.groupPadding"
      (select)="mSelectedEvent($event)">
    </ngx-charts-bar-vertical-2d>
</div>
<no-data *ngIf="(!data) || (data.length <= 0)"></no-data>`,
  styles: [`.chart-container{width:100%;height:100%}`]
})
export class BarVerticalGroupedComponent implements OnInit {

    @Input('data') data: any;
    @Input('options') customOptions: BarGroupedOptions;
    @Output() onSelect : EventEmitter<any> = new EventEmitter<any>();

    options: BarGroupedOptions = new BarGroupedOptions();

    colorScheme = customColorSets.find(s => s.name == 'palatte');

    constructor() { }

    ngOnInit() {
        Object.assign(this.options, this.customOptions);
    }

    mSelectedEvent(event: any) {
        this.onSelect.emit(event);
    }

}
